import { Divider } from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";



function DropdownMenu  ({ submenus, isProfile, isVisible }) {

    return (
      <>
      {isVisible && <div className="dropdown-menu">
        <ul>
          {submenus.map((submenu, index) => (
            <li key={index} style={index === submenus.length-1 ? {paddingBottom:"4px"}: {}}>
              { submenu.title ? (<div><div className="menu-item"><Link to={submenu.url}>{submenu.title}</Link></div>
              {index !== submenus.length-1 && <Divider/>}
              </div>) :
               (
                   <div className="profile-items"><span className="header-text">{ submenu.name }</span>{submenu.value}</div>
               )
              }
              
            </li>
          ))}
        </ul>
      </div>}


      </>
    );
  };
  
  export default DropdownMenu;